/** @graphql cc **/
import gql from 'graphql-tag';

export const GetLicensedProductsQuery = gql`
	query GetLicensedProductsQuery {
		confluence_tenantContext {
			licensedProducts {
				licenseStatus
				productKey
			}
		}
	}
`;
